import React from 'react'
import testmonial2 from '../Image/testmonial2.avif'
import testmonial3 from '../Image/testmonial3.avif'
import testmonial4 from '../Image/testmonial4.avif'
import testmonial1 from '../Image/testmonial1.avif'
import testmonial5 from '../Image/testmonial5.avif'
import testmonial6 from '../Image/testmonial6.avif'
import { Splide, SplideSlide } from '@splidejs/react-splide';

function Testmonial_page() {
  return (
    <div>

        {/* --------------------------Mobile View------------------------------ */}
        <div class="container Testmonial_container d-sm-block d-md-none">
            <div class="row">
                <div class="col-lg-4">
                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial2}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Vaibhav Gupta
                            </div>
                            <div class="designation">SSIPMT RAIPUR CSE</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                                " I like to thank that I was offered exemplary quality training and I was constantly examining my own practice to improve our program overall training of good "
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial1}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Pranaav B V 
                            </div>
                            <div class="designation">Vellore Institute of Technology</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                            " It was a good experience. The interactions both on and off class hours were what really impressed me. Be it any time of the day, both the teacher and the representative are present to clarify your doubts and help you however possible. "
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">

                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial3}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Kajal Mishra 
                            </div>
                            <div class="designation">Manav rachna University</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                            " Overall, I found the program to be highly valuable and well-structured, and I appreciate the opportunity to have been a part of it .I am grateful for the mentorship provided throughout the internship. "
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-4">
                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial4}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Gagan deep k
                            </div>
                            <div class="designation">VVIT CSE</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                            It was very good experience training in the company and which helped me improve my skills and knowledge. The company provided very good knowledge on the field of training and about new technology in the professional field.
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial5}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Devesh Kumar 
                            </div>
                            <div class="designation">Dr. V S Institute of Computer Studies</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                            The training provided by Internselite was conducted in a very professional and highly intellectual way the our mentor was very helpful and was handled the course in with utmost professionalism.
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial6}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Abanti Mukherjee
                            </div>
                            <div class="designation">Techno India University (BCA)</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                            " The feedback that I would like to provide is that is quite good for enhancing the skills of the student which would add to their resume. "
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* --------------------------desktop View------------------------------ */}
        <div class="container Testmonial_container my-3 d-none d-md-block">
            <div class="row">
                <div class="col-lg-4">
                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial2}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Vaibhav Gupta
                            </div>
                            <div class="designation">SSIPMT RAIPUR CSE</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                            " I like to thank that I was offered exemplary quality training and I was constantly examining my own practice to improve our program overall training of good "
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial1}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Pranaav B V
                            </div>
                            <div class="designation">Vellore Institute of Technology</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                            " It was a good experience. The interactions both on and off class hours were what really impressed me. Be it any time of the day, both the teacher and the representative are present to clarify your doubts and help you however possible. "
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">

                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial3}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Kajal Mishra 
                            </div>
                            <div class="designation">Manav rachna University</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                            " Overall, I found the program to be highly valuable and well-structured, and I appreciate the opportunity to have been a part of it .I am grateful for the mentorship provided throughout the internship. "
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row my-5">
                <div class="col-lg-4">
                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial4}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Gagan deep k
                            </div>
                            <div class="designation">VVIT CSE</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                            It was very good experience training in the company and which helped me improve my skills and knowledge. The company provided very good knowledge on the field of training and about new technology in the professional field.
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial5}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Devesh Kumar 
                            </div>
                            <div class="designation">Dr. V S Institute of Computer Studies</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                            The training provided by Internselite was conducted in a very professional and highly intellectual way the our mentor was very helpful and was handled the course in with utmost professionalism. 
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="testmonial_card">
                        <div class="face front-face">
                            <img src={testmonial6}
                                alt="" class="profile"></img>
                            <div class="pt-3 text-uppercase name">
                            Abanti Mukherjee
                            </div>
                            <div class="designation">Techno India University (BCA)</div>
                        </div>
                        <div class="face back-face">
                            <span class="fas fa-quote-left"></span>
                            <div class="testimonial">
                            " The feedback that I would like to provide is that is quite good for enhancing the skills of the student which would add to their resume. "
                            </div>
                            <span class="fas fa-quote-right"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Testmonial_page
